class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.onFocusOutHandler = this.onFocusOut.bind(this);
    this.onToggleHandler = this.onToggle.bind(this);
    this.onDocumentClickHandler = this.onDocumentClick.bind(this);

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOutHandler);
    this.mainDetailsToggle.addEventListener('toggle', this.onToggleHandler);
    document.addEventListener('pointerdown', this.onDocumentClickHandler);
  }

  onFocusOut() {
    // fallback close on tab focus shift (keyboard nav)
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onDocumentClick(event) {
    // close menu if click is outside
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.onDocumentClickHandler);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    super.onToggle();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);